import React, { useCallback, useState } from 'react'
import { IOrderPrice } from 'order_components/IOrder'
import { Row } from 'react-bootstrap'
import OrderInfoForm from './cart_forms/OrderInfoForm'
import { useNavigate } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { productsRecoilState } from 'product/ProductsState'
import { useCart } from 'cart/CartProvider'
import { useAuth } from 'auth/AuthProvider'
import NameInput from '../components/inputs/NameInput'
import PhoneInputWithConfirm from './cart_forms/PhoneInputWithConfirm'
import RoundButton from 'components/inputs/RoundButton'
import { reqCalculateCartOrderPrice, reqRequestCartOrder } from 'cart/CartRequests'
import { reqGetAllProducts } from 'product/ProductRequests'
import { PAGE_URL_ACTIVE, SP_NEW_ORDER } from 'SiteURLs'
import CartInfoPhaseButtons from './CartInfoPhaseButtons'
import { reqStartPayment } from 'pay_work/PaymentRequests'
import { payWithSber } from 'pay_work/PayRequests'
import EmailInput from 'components/inputs/EmailInput'

interface IRequestInfoPhaseProps {
  orderPrice: IOrderPrice
  noProducts: boolean
  onGoToPrevScreen: VoidFunction
  onChange: VoidFunction
  onError: (error: string) => void
}

const RequestInfoPhase: React.FC<IRequestInfoPhaseProps> = ({
  orderPrice,
  noProducts,
  onGoToPrevScreen,
  onChange,
  onError,
}) => {
  const auth = useAuth()
  const [cart, cartAct] = useCart()
  const setProducts = useSetRecoilState(productsRecoilState)
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [code, setCode] = useState<number | null>(null)
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)

  const handleEnterPhone = useCallback(
    (phone, code) => {
      setPhone(phone)
      setCode(code)
      cartAct.updatePrarmeter('extra_phone_number', phone)
    },
    [cartAct]
  )

  const requestCartOrder = useCallback(
    (onSuccess: VoidFunction) => {
      setIsLoading(true)
      reqRequestCartOrder(
        (responce) => {
          setIsLoading(false)
          if (responce.status === 'OK') {
            reqGetAllProducts(setProducts)
            onSuccess()
          } else if (responce.status === 'BAD_CODE') {
            onError('Неверный код или его срок действия истек')
          } else if (responce.status === 'INVALID_PHONE_NUMBER') {
            onError('Подтвердите номер телефона')
          } else if (responce.status === 'TOO_MANY_ACTIVE_ORDERS') {
            onError('Слишком много активных заказов')
          } else if (responce.status === 'INVALID_NAME') {
            onError('Введите имя')
          } else if (responce.status === 'NO_PRODUCTS_IN_OFFICE') {
            onError('Один или несколько товаров из списка отсутствует в выбранном офисе')
            cartAct.refresh()
            onGoToPrevScreen()
            reqGetAllProducts(setProducts)
          } else {
            onError('Сервис временно недоступен, повторите попытку позже')
          }
        },
        name,
        phone,
        email,
        code || undefined
      )
    },
    [name, phone, email, code, cartAct, onGoToPrevScreen, onError, setProducts]
  )

  const handleRequest = useCallback(() => {
    if (orderPrice.total_price !== 0) {
      requestCartOrder(() => {
        if (!auth.user) {
          auth.signinWithToken(() => {})
        } else {
          cartAct.refresh()
        }
        navigate('/' + PAGE_URL_ACTIVE + '?' + SP_NEW_ORDER + '=1')
      })
    }
  }, [auth, navigate, orderPrice, cartAct, requestCartOrder])

  const handleGoToPayment = useCallback(() => {
    if (!!cart && !!orderPrice && orderPrice.total_price > 0) {
      reqCalculateCartOrderPrice(
        (orderPrice_) => {
          const price = orderPrice_.total_price
          // const price = 1

          requestCartOrder(() => {
            if (!auth.user) {
              auth.signinWithToken(() => {})
            } else {
              cartAct.refresh()
            }

            reqStartPayment(cart.order_id, (login?: string) => {
              if (!login) {
                onError('Сервис временно не доступен')
              } else {
                // Если клиент нажмет на кнопку "назад" в браузере, он перейдет на страницу активных заказов
                // с уведомлением о том, что заказ оформлен
                window.history.pushState(
                  { dummystate: 1 },
                  'active_orders',
                  '#/' + PAGE_URL_ACTIVE + '?' + SP_NEW_ORDER + '=1'
                )

                //sucess
                payWithSber(login, cart.order_id, price, (message: string) => {
                  onError(message)
                })
              }
            })
          })
        },
        () => {
          onError('Сервис временно не доступен')
        }
      )
    }
  }, [orderPrice, auth, cart, cartAct, requestCartOrder, onError])

  const handleUpdateOrder = useCallback(
    (parameterKey: string, value: string | number | null) => {
      cartAct.updatePrarmeter(parameterKey, value)
      onChange()
    },
    [onChange, cartAct]
  )

  return (
    <>
      {cart && (
        <>
          {!auth.user && (
            <>
              <RoundButton
                color='outlined'
                onClick={auth.showSignInDialog}
                className='mb-2'
              >
                Есть учетная запись? Войти!
              </RoundButton>

              <NameInput onChange={setName} />

              <PhoneInputWithConfirm order={cart} onEntered={handleEnterPhone} />

              <EmailInput
                placeholder='Почта (не обязательно)'
                defaultValue={email}
                onChange={setEmail}
                style={{ width: '100%' }}
              />
            </>
          )}
          <OrderInfoForm
            order={cart}
            showExtraPhone={!!auth.user}
            onChange={handleUpdateOrder}
          />

          <Row className='gy-2'>
            <CartInfoPhaseButtons
              cart={cart}
              orderPrice={orderPrice}
              noProducts={noProducts}
              isLoading={isLoading}
              onGoToPrevScreen={onGoToPrevScreen}
              onRequestWithoutPayment={handleRequest}
              onRequestWithPayment={handleGoToPayment}
            />
          </Row>
        </>
      )}
    </>
  )
}
export default RequestInfoPhase
